<script setup lang="ts">
defineProps<{
  /** Accessible name of the separator. */
  label: string
  /** Current width of the panel the handle resizes, in px. */
  valueNow: number
  /** Smallest width the panel can take, in px. */
  valueMin: number
  /** Largest width the panel can take, in px. */
  valueMax: number
  /** Lights the line while a drag is live. */
  dragging?: boolean
}>()
</script>

<template>
  <button
    type="button"
    role="separator"
    aria-orientation="vertical"
    :aria-valuenow="valueNow"
    :aria-valuemin="valueMin"
    :aria-valuemax="valueMax"
    :aria-label="label"
    class="group absolute inset-0 cursor-col-resize outline-none"
  >
    <span
      class="pointer-events-none absolute inset-y-4 left-1/2 w-1 -translate-x-1/2 rounded-full transition-colors duration-fast ease-soft"
      :class="
        dragging
          ? 'bg-accent-blue'
          : 'bg-transparent group-hover:bg-border-strong group-focus-visible:bg-accent-blue'
      "
    />
  </button>
</template>
